import type { StateTree } from 'pinia';

/**
 * serializer: use custom serializer that persists Date (TZDate) objects and undefined values.
 */
const persistSerializer = {
    deserialize: (v: string) => {
        try {
            return v ? parseWithReviver(v) : null;
        }
        catch (error) {
            logSilentSentryError(new Error('Error parsing pinia localStorage', { cause: error }), {
                rawValue: v,
            });
            return null;
        }
    },
    serialize: (v: StateTree) => stringifyWithReplacer(v),
};

/**
 * Default Store Persist Options for "Pinia Persisted State Plugin" that uses localStorage storage
 * and a custom serializer to handle Date objects.
 *
 * storage: use safeLocalStorage to avoid issues when users have disabled localStorage in their browser.
 * serializer: use custom serializer that persists Date objects and undefined values.
 */
const storePersistOptions = {
    storage: safeLocalStorage,
    serializer: persistSerializer,
};

export default {
    storePersistOptions,
};
